import { css } from '@emotion/react';
import sctheme from 'app/styles/sctheme';

const styles = sctheme => css`
  .status-pill {
    width: auto;
    padding: 0.25rem 2rem;
    text-transform: uppercase;
    color: ${sctheme.white};
    border-radius: 20px;
    font-weight: bold;
    text-align: center;
    text-wrap-mode: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    &.small {
      padding: 2px 8px;
      width: fit-content;
    }

    &.active {
      background-color: ${sctheme.statuses.active};
    }

    &.pending {
      background-color: ${sctheme.statuses.pending};
      color: ${sctheme.grays.$900};
    }

    &.waitlisted {
      background-color: ${sctheme.statuses.waitlisted};
    }

    &.cancelling {
      background-color: ${sctheme.statuses.cancelling};
      color: ${sctheme.grays.$900};
    }

    &.terminated {
      background-color: ${sctheme.statuses.terminated};
    }

    &.none {
      background-color: ${sctheme.statuses.none};
      color: ${sctheme.grays.$900};
    }
  }
`;

export default styles(sctheme);
